import React, { Component } from 'react';
import {
  EnrollIntroduction,
  EnrollDoubleInput,
  EnrollSuccess,
  DeviceList as DeviceListComponent
} from '@imprivata/nucleus';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';

import * as actions from '../../../actions';
import Logout from '../../shared/Logout';
import { doesInclude } from '../../../Util';

/**
 * ImprivataIdEnroll Component
 */
export class ImprivataIdEnroll extends Component {
  /**
   * The allowed properties for the ImprivataIdEnroll component
   * @param {function} enrollImprivataId enrolls the given imprivataId app with the given serial number and token code
   * @param {function} imprivataIdEnrolled returns whether or not the imprivataId app is enrolled successfully
   * @param {function} inputEnrollImprivataId triggers the introduction for enrolling the imprivataId app
   * @param {function} skipEnrollment skips enrolling the imprivataId app
   * @param {function} changeEnrollModality changes the enrollment modality to be used
   * @param {bool} isLoading is something on the page loading?
   * @param {number} serverStateVersion The current server state version
   * @param {array} errorCode The original error code
   * @param {array} errorMessage the error messages to be displayed
   * @param {string} currentStep the current enrollment step
   * @param {bool} canSkipEnrollment can the user skip this enrollment step?
   * @param {bool} canChangeEnrollmentModality can the user change the modality to enroll?
   */
  static propTypes = {
    enrollImprivataId: PropTypes.func.isRequired,
    imprivataIdEnrolled: PropTypes.func.isRequired,
    inputEnrollImprivataId: PropTypes.func.isRequired,
    skipEnrollment: PropTypes.func.isRequired,
    changeEnrollModality: PropTypes.func.isRequired,
    isLoading: PropTypes.bool,
    serverStateVersion: PropTypes.number,
    errorCode: PropTypes.string,
    errorMessage: PropTypes.array,
    currentStep: PropTypes.string,
    canSkipEnrollment: PropTypes.bool,
    canChangeEnrollmentModality: PropTypes.bool,
    isDeviceManagementWorkflow: PropTypes.bool,
    isOnboardingWorkflow: PropTypes.bool,
  };

  submitIntroduction = () => {
    this.props.inputEnrollImprivataId();
  };

  submitInput = data => {
    this.props.enrollImprivataId(data.serial, data.tokenCode);
  };

  submitSuccess = () => {
    clearTimeout(this.successWaitTimeout);
    this.props.imprivataIdEnrolled();
  };

  changeEnrollmentModality = () => {
    this.props.changeEnrollModality('sms');
  };

  buildCapabilityList = (capability) => {
    let capabilityList = '';
    capabilityList = capabilityList.concat(capability);
    return capabilityList;
  };


  render() {
    const stepIntroduction = (
      <EnrollIntroduction
        headerTitle='Imprivata ID'
        setupTime='2 minutes'
        setupRequirements='Your smartphone'
        submitText='Enroll Imprivata ID'
        timerImage={require('./timer_icon.png')}
        wynImage={require('./wyn_icon.png')}
        onSubmitClicked={this.submitIntroduction}
        canSkipEnrollment={this.props.canSkipEnrollment}
        onSkipEnroll={this.props.skipEnrollment}
        linkText={(this.props.canSkipEnrollment === true)
          ? 'Not now'
          : null}
        canEnrollAlternativeText={
          (this.props.canChangeEnrollmentModality === true)
            ? 'Enroll another method'
            : null
        }
        onEnrollAnother={this.changeEnrollmentModality}
        logoutComponent={<Logout />}
      >
        <p className='header-description'>
          Get fast access by approving a notification on your smartphone
        </p>
      </EnrollIntroduction>
    );
    const stepInput = (
      <EnrollDoubleInput
        headerTitle='Enroll Imprivata ID'
        serialPlaceholderText='Serial Number (e.g. IMPR 1234 5678)'
        tokenCodePlaceholderText='Token Code (e.g. 123456)'
        serialInputType='imprSerialNumber'
        tokenCodeInputType='number'
        maxLengthSecondField='6'
        autoFocus={true}
        canSkipEnrollment={this.props.canSkipEnrollment}
        displayErrors={this.props.errorMessage}
        linkText={this.props.isOnboardingWorkflow ? 'Back' : 'Not now'}
        onLinkClicked={this.props.isOnboardingWorkflow ? this.props.backToIntroduction : this.submitSuccess}
        submitText='Submit'
        onSubmit={this.submitInput}
        logoutComponent={<Logout />}
        postScript={'Enrolling your phone in Imprivata ID allows us to use your phone to enable fast and secure logins.'}
      >
        {this.props.isDeviceManagementWorkflow ?
          (<div>
            <ol className='list-outside'>
              <li>
              Open the Imprivata ID app on your smartphone
              </li>
              <li>
              Enter the serial number and token code from the app below
              </li>
              <li>In Imprivata ID, review and update feature access if needed</li>
            </ol>
          </div>) :
          (<div>
            <ol className='list-outside'>
              <li>
              Download and open the Imprivata ID app on your smartphone
              </li>
              <li>
              Turn on notifications and other relevant permissions as prompted
              </li>
              <li>Enter the serial number and token code from the app below</li>
            </ol>
          </div>)
        }
      </EnrollDoubleInput>
    );
    let capabilitiesToRender = '';
    // Check if Fortuna
    try {
      capabilitiesToRender = this.props.capabilities.DeviceManagement[0].functions.map(this.buildCapabilityList);
    }
    catch (error) {
      try {
        // Check if Europa
        if (this.props.capabilities.DeviceManagement.version != null) {
          capabilitiesToRender = 'enroll';
        }
      }
      catch (error) {
        capabilitiesToRender = '';
      }
    }
    let stepSuccess;
    if(this.props.isDeviceManagementWorkflow === true && doesInclude(capabilitiesToRender, 'list') ) {
      (stepSuccess =
          <div className='content-body'>
            <DeviceListComponent
              headerType='Success-Header-Box'
              devices={this.props.deviceList}
              logoutComponent={null}
              headerTitle={'New device added'}
              continueLink={<btn onClick={this.submitSuccess}>Done</btn>}
              headerDescription={this.props.deviceList != null && this.props.deviceList.length > 0 ? this.props.deviceList[0].displayName + ' can now be used for authentication' : 'Your device can now be used for authentication'}
              enrollDeviceLink={null}
            />
          </div>
      );
    }
    else {
      (stepSuccess =
        <EnrollSuccess
          headerTitle={'Imprivata ID enrolled'}
          enrollImage={require('../../../images/success_IID_enroll.png')}
          buttonText={this.props.isOnboardingWorkflow && this.props.canChangeEnrollmentModality ? 'Next: enroll backup method' : 'Done'}
          onButtonClicked={this.submitSuccess}
          linkText={this.props.isOnboardingWorkflow && this.props.canChangeEnrollmentModality ? 'Not now' : null}
          onLinkClicked={this.props.isOnboardingWorkflow && this.props.canChangeEnrollmentModality ? this.props.skipEnrollment : null}
          logoutComponent={<Logout />}
          imageWidth='100%'
        >
          The next time you log in, approve a push notification to verify your identity.
        </EnrollSuccess>
      );
    }
    let currentStepToRender;
    switch (this.props.currentStep) {
    case 'stepInput':
      currentStepToRender = stepInput;
      break;
    case 'stepSuccess':
      if(this.props.authenticationToken !== null){
        this.successWaitTimeout = setTimeout( () => this.submitSuccess(), 50000);
      }
      currentStepToRender = stepSuccess;
      break;
    case 'stepIntroduction':
      // falls through
    default:
      currentStepToRender = stepIntroduction;
    }
    return <div className='content-body'>{currentStepToRender}</div>;
  }
}


const mapStateToProps = state => {
  const {
    capabilities,
    serverStateVersion,
    errorCode,
    errorMessage,
    isLoading,
    phoneNumber,
    currentStep,
    modality,
    deviceList,
    canSkipEnrollment,
    canChangeEnrollmentModality,
    isOnboardingWorkflow,
    isDeviceManagementWorkflow,
    authenticationToken,
  } = state.login;
  return {
    capabilities,
    isLoading,
    serverStateVersion,
    errorCode,
    errorMessage,
    phoneNumber,
    currentStep,
    modality,
    deviceList,
    canSkipEnrollment,
    canChangeEnrollmentModality,
    isOnboardingWorkflow,
    isDeviceManagementWorkflow,
    authenticationToken,
  };
};

const mapDispatchToProps = dispatch => {
  return {
    moveOn: () => {
      dispatch(actions.endDeviceManagementSession);
      dispatch(actions.actuallyEndDeviceManagementSession() );
      dispatch(actions.endIgnoreTimeout() );
      dispatch(actions.submitAfterSSDM() );
    },
    inputEnrollImprivataId: () => {
      dispatch(actions.inputEnrollImprivataId() );
    },
    enrollImprivataId: (serialNumber, tokenCode) => {
      dispatch(actions.enrollImprivataId(serialNumber, tokenCode) );
    },
    imprivataIdEnrolled: () => {
      dispatch(actions.imprivataIdEnrolled() );
    },
    backToIntroduction: () => {
      dispatch(actions.backToIntroduction() );
    },
    skipEnrollment: () => {
      dispatch(actions.skipEnrollment() );
    },
    changeEnrollModality: modality => {
      dispatch(actions.changeEnrollModality(modality) );
    },
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(ImprivataIdEnroll);
